import PropTypes from 'prop-types';

const RoomNumberLabel = ({ roomNumber }) => (
  <div className="mx-auto flex items-center gap-2 rounded-lg  border-2 border-pj-primary-400 bg-pj-primary-400 font-semibold">
    <span className="rounded-lg bg-white px-4 py-1 font-bold">
      Room
    </span>
    <span className="min-w-8 rounded-lg px-4 py-1 pl-2 text-pj-good-contrast">
      {roomNumber}
    </span>
  </div>
);
RoomNumberLabel.propTypes = {
  roomNumber: PropTypes.string.isRequired,
};

export default RoomNumberLabel;
